<template>
  <div v-if="disableArrow">
    <div class="flex justify-between gap-5 border-b items-center border-cockpit-green/50">
      <h2 class="py-3 font-bold text-xl grow">{{ props.title }}</h2>
      <slot name="header" />
    </div>
    <TransitionY>
      <div class="py-3">
        <slot></slot>
      </div>
    </TransitionY>
  </div>
  <div v-else>
    <div class="flex justify-between gap-5 border-b items-center cursor-pointer text-cockpit-text" :class="open ? 'border-cockpit-green/50' : 'border-cockpit-line'">
      <h2 class="py-3 font-bold text-xl grow" @click="open = !open">{{ props.title }}</h2>
      <slot name="header" />
      <i @click="open = !open" :class="[{ 'rotate-180': open }, 'fa fa-chevron-down']"></i>
    </div>
    <TransitionY>
      <div v-if="open" class="py-3">
        <slot></slot>
      </div>
    </TransitionY>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps({
  title: String,
  disableArrow: { type: Boolean, default: false },
})

const open = ref(true)
</script>
